module.exports = __webpack_public_path__ + "site/img/55.f801118a.jpg";